/** Width (px) below which a formular with a single field group renders that group full width. */
export const SINGLE_GROUP_FULL_WIDTH_MAX = 900

/** True if the only field group of a single-page top-level formular should span the full width:
 * the formular's own available width (not the viewport) is narrower than SINGLE_GROUP_FULL_WIDTH_MAX.
 * Unknown width (not yet measured) keeps the existing half-width layout.
 */
export function singleGroupFullWidth({isSubtype, maxPages, visibleGroupCount, width}) {
  if (isSubtype || maxPages !== 1 || visibleGroupCount !== 1) return false
  if (typeof width !== 'number' || !(width > 0)) return false
  return width < SINGLE_GROUP_FULL_WIDTH_MAX
}

/** CSS class of a field group. A configured "col-" class of the group's first field always wins. */
export function fieldGroupClass(cssClass, fullWidth) {
  if (cssClass && cssClass.includes('col-')) return cssClass + ' '
  return fullWidth ? 'col-12 ' : 'col-sm-6 col-xs-12 '
}
